// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__15p5v","title":"Info_title__n6JFA","selects":"Info_selects__26GWr","requiredAsterisk":"Info_requiredAsterisk__3zA1W"};